// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../.config/yarn/global/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st0[data-v-522bba5e]{fill:#fff}.st1[data-v-522bba5e]{fill:none;stroke:#b5b5b5;stroke-miterlimit:10}.st2[data-v-522bba5e]{fill:none;stroke:#408eff;stroke-linecap:round;stroke-miterlimit:10}.st3[data-v-522bba5e]{fill:#408eff}", ""]);
// Exports
module.exports = exports;
